import styled from "@emotion/styled";
import { GenderSelectBtnProps } from "./../../../types/styles/styles";

// styled components

export const H5 = styled.h5`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #242424;
  margin: 10px 0;
`;

export const H5Red = styled.h5`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #da3923;
  margin: 10px 0;
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 11px 28px;
  gap: 10px;
  height: 42px;
  background: ${(Props) => (Props?.color === "alert" ? "#da3923" : "inherit")};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  border: ${(Props) =>
    Props?.color === "alert" ? "none" : "1px solid #dcdcdc"};
  border-radius: 4px;
  color: ${(Props) => (Props?.color === "alert" ? "#ffffff" : "#606164")};
  :focus {
    outline: none;
  }
  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const buttonStyle = {
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: "800",
  fontSize: "12px",
  lineHeight: "18px",
  // textAlign: "left",
  color: "#606164",
};

export const titleButton = {
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "29px",
  color: "#333333",
};
// sx
export const textFieldStyle = {
  width: "100%",
  margin: "10px 0",
};
export const textInputStyle = {
  width: "100%",
  margin: "10px 0",
  background: "#DCDCDC",
  padding: "10px",
};

export const GenderSelectBtn = styled.button<GenderSelectBtnProps>`
  padding: 8px 20px;
  gap: 10px;
  height: 36px;
  border-radius: 20px;
  font-size: 16px;
  line-height: 20px;
  border: ${(Props) =>
    Props?.selected ? "1px solid #E1614F" : "1px solid rgba(36, 36, 36, 0.12)"};
  color: #606164;
  margin: 10px 10px 10px 0;
  cursor: pointer;
  background-color: ${(Props) => (Props?.selected ? "#f5f5f5" : "inherit")};
  &:hover {
    cursor: pointer;
    background-color: #f5f5f5;
  }
  &:disabled {
    cursor: not-allowed;
    background-color: #f5f5f5;
    border: ${(Props) =>
      Props?.selected ? "1px solid #E1614F" : "1px solid rgba(36, 36, 36, 0.12)"};
  }
`;
export const sidebarStyle = {
  display: "flex",
  minHeight: "calc(100vh - 64px)",
};
export const textRedStyle = { color: "#DA3923", textDecoration: "underline" };
export const dividerStyle = { m: "10px 0", color: "#DA3923" };
export const patientTableBtnStyle = {
  padding: "5px 16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
export const actionSx = {
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  gap: "5px",
};

export const boxFlex = {
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
};

export const stepBoxContainer = {
  ...boxFlex,
  gap: "20px",
  margin: "20px 0",
};

export const stepBox = { ...boxFlex, gap: "15px", cursor: "pointer" };

export const patientSx = {
  error: {
    color: "#DA3923",
    margin: "0 0 20px 0",
  },
  colorGray: { color: "#606164" },

  buttonStyle: {
    fontFamily: "Montserrat",
    fontStyle: "normal",
    fontWeight: "800",
    fontSize: "12px",
    lineHeight: "18px",
    textAlign: "center",
    color: "#606164",
  },

  titleButton: {
    fontFamily: "Montserrat",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "29px",
    color: "#333333",
  },

  textFieldStyle: {
    width: "100%",
    margin: "10px 0",
  },

  textInputStyle: {
    width: "100%",
    margin: "10px 0",
    background: "#DCDCDC",
    padding: "10px",
  },

  sidebarStyle: {
    display: "flex",
    minHeight: "calc(100vh - 64px)",
  },

  textRedStyle: { color: "#DA3923", textDecoration: "underline" },

  dividerStyle: { m: "10px 0", color: "#DA3923" },

  patientTableBtnStyle: {
    padding: "5px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  actionSx: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: "5px",
  },

  stepFormTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "35px",
    "@media (max-width: 900px)": {
      marginTop: "20px",
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
  },

  boxFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
  },

  stepBoxContainer: {
    ...boxFlex,
    gap: "20px",
    margin: "20px 0",
  },

  stepBox: { ...boxFlex, gap: "15px", cursor: "pointer" },
  filterSpan: {
    fontFamily: "Montserrat",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#242424",
    padding: "10px 0",
  },
  secondPopContainer: { position: "absolute", top: "0", right: "0" },

  secondPopupCheckbox: {
    padding: "0 20px ",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },

  checkBoxFill: {
    color: "#E1614F",
    fill: "#E1614F",
  },
  iconBtn: { minWidth: "auto", p: 0 },
};
